import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiX } from 'react-icons/fi';
import './WebinarModal.css';

const SpeakerModal = ({ open, onClose, speaker }) => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    middle_name: '',
    credentials: '',
  });
  const [photoFile, setPhotoFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (speaker) {
      setFormData({
        first_name: speaker.first_name || '',
        last_name: speaker.last_name || '',
        middle_name: speaker.middle_name || '',
        credentials: speaker.credentials || '',
      });
      setPhotoFile(null);
    } else {
      // Очищаем форму при создании нового спикера
      setFormData({
        first_name: '',
        last_name: '',
        middle_name: '',
        credentials: '',
      });
      setPhotoFile(null);
    }
  }, [speaker, open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });
      if (photoFile) {
        data.append('photo', photoFile);
      }

      if (speaker) {
        await axios.patch(`/api/speakers/${speaker.id}/`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        toast.success('Спикер обновлен');
      } else {
        await axios.post('/api/speakers/', data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        toast.success('Спикер создан');
      }
      // Очищаем форму после успешного сохранения
      setFormData({
        first_name: '',
        last_name: '',
        middle_name: '',
        credentials: '',
      });
      setPhotoFile(null);
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.error || 'Ошибка сохранения');
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{speaker ? 'Редактировать спикера' : 'Добавить спикера'}</h2>
          <button className="modal-close" onClick={onClose}>
            <FiX />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label className="form-label">Фамилия *</label>
            <input
              type="text"
              className="form-input"
              value={formData.last_name}
              onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Имя *</label>
            <input
              type="text"
              className="form-input"
              value={formData.first_name}
              onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Отчество</label>
            <input
              type="text"
              className="form-input"
              value={formData.middle_name}
              onChange={(e) => setFormData({ ...formData, middle_name: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Фото</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setPhotoFile(e.target.files[0])}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Регалии/Описание *</label>
            <textarea
              className="form-textarea"
              value={formData.credentials}
              onChange={(e) => setFormData({ ...formData, credentials: e.target.value })}
              rows="6"
              required
            />
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-outline" onClick={onClose}>
              Отмена
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Сохранение...' : 'Сохранить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SpeakerModal;
